export const DEFAULT_EDITOR_DEFINITION_ID = 'default';
;
;
// if a model has these props they'll automatically be exposed as readonly.
// if some must be editable, add them to prop list with "true" explicitly.
export const editorDefinitionWhitelistedProps = ['id', 'creationDate', 'updateDate', 'ownerId'];
export const EDITOR_MODELS_CACHE_KEY = '__EDITOR_MODELS_CACHE__';